import '../../App.css';
import React, { useContext, useState } from "react";
import { FaTimes } from 'react-icons/fa';
import { Form, Row, Col } from 'react-bootstrap';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';

function ModalEditarCadastro({ end, currentPage }) {

    const { setModalEditar, DemandaAtual, EditarItensDemanda, Permissao } = useContext(ApiContext)
    const [Descricao, setDescricao] = useState(DemandaAtual.descricao)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const editarItensDemanda = () => {
        EditarItensDemanda(end, Descricao, DemandaAtual.key, DemandaAtual.idExterno, currentPage)
            .then(() => {
                setModalEditar(false)
            })
            .catch((error) => {
                console(error)
            })
    }

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar cadastro</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditar(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Row>
                            <Form.Group className="mb-3">
                                <Form.Label>Descrição</Form.Label>
                                <Form.Control as='textarea' rows={3} maxLength={255} defaultValue={DemandaAtual.descricao} onChange={(e) => setDescricao(e.target.value)} name="descricao" />
                            </Form.Group>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditar(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editarItensDemanda();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarCadastro